// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"98":"eb8ecb75","871":"5e3faf3b"}[chunkId] + ".chunk.css";
};